







import Vue from 'vue';
import Component from 'vue-class-component';
import { mapGetters, mapState } from 'vuex';
import { SUBMODULES_PATHS } from '../../store';
import { CONFIG_GETTERS_KEYS } from '../../store/config/config.const';

@Component({
  computed: {
    ...mapGetters(SUBMODULES_PATHS.config, {
      components: CONFIG_GETTERS_KEYS.components
    }),
    ...mapState(SUBMODULES_PATHS.search, [
      'numFound',
      'query'
    ])
  }
})
export default class ResultsNumber extends Vue {}
